import React from 'react'
import { bool, string } from 'prop-types'
import classNames from '../../helpers/class-names'

import Spinner from '../spinner'

const blk = 'asda-btn'

const Loading = ({
  loading,
  loadingWithLabel,
  outline,
  category,
}) => {
  if (loading && loadingWithLabel) {
    return (
      <Spinner
        isCenter={false}
        size="small"
        category={outline ? category : `${category}-light`}
        className={classNames({ blk, elt: 'spinner-with-label' })}
      />
    )
  }

  if (loading) {
    return (
      <div className={classNames({
        blk,
        elt: 'spinner',
        mods: [
          !outline && category,
          outline && 'outline',
        ],
      })}
      >
        <Spinner isCenter={false} size="small" category={outline ? category : `${category}-light`} />
      </div>
    )
  }
  return null
}

Loading.propTypes = {
  loading: bool,
  loadingWithLabel: bool,
  outline: bool,
  category: string,
}

Loading.defaultProps = {
  loading: false,
  loadingWithLabel: false,
  outline: false,
  category: 'primary',
}

export default Loading



// WEBPACK FOOTER //
// ./common/components/button/loading.js